import React, { useState, useEffect, useRef, useContext } from "react";
import { fabric } from "fabric";
import "./index.css";
import axios from "axios";
import { Indianlanguages } from "../src/assets/Json/laanlist";
import { AppContext } from "../src/context";
import TranslatorInput from "../src/Components/trans";
import { useNavigate } from "react-router";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Translator = () => {
  const canvasRef = useRef(null);
  const divRef = useRef(null);
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState();
  const [steps, setSteps] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [blankImageUrl, setblankImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [keyboardview, setkeyboardview] = useState(false);
  const [editimg, seteditimg] = useState(false);
  const contextData = useContext(AppContext);

  const buttonStyle = {
    width: "180px",
  };
  const buttonStyleNew = {
    width: "88px",
  };

  useEffect(() => {
    setSelectedImage(contextData.data.file);
    setSelectedLanguage(contextData.data.lang);
    translateImage(contextData.data.lang, contextData.data.file);
  }, []);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleChooseFile = () => {
    setSteps(true);
  };

  const handleImageUrlChange = (event) => {
    const url = event.target.value;
    setImageUrl(url);
  };

  const handleLanguageChange = (event) => {
    const language = event.target.value;
    setSelectedLanguage(language);
  };

  const translateImage = async (selectedLanguage, selectedImage) => {
    setLoading(true); // Show the loader when axios call is initiated

    let formdata = {
      output_lang: selectedLanguage,
      image: contextData.data.file,
    };
    try {
      const response = await axios.post(
        "https://image123.aicte-india.org/image_inpainting",
        formdata,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status === 200) {
        // setblankImageUrl(response.data.result.file_path);
        var divElement = document.getElementById("loader_text");
        divElement.innerHTML =
          "Image translation & text layout in-progress....";

        // Generate options for font sizes from 1 to 50
        const sizeSelect = document.getElementById("fontSize");
        for (let i = 1; i <= 50; i++) {
          const option = document.createElement("option");
          option.value = i;
          option.text = i;
          sizeSelect.appendChild(option);
        }
        // Generate options for font sizes from 1 to 50

        const convertedUrl = response.data.result.file_path.replace(
          "/blank/",
          "/"
        );
        let trans_formdata = {
          output_lang: contextData.data.lang,
          input_image: convertedUrl,
        };

        try {
          const trans_response = await axios.post(
            "https://image123.aicte-india.org/image_transformation",
            trans_formdata,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          if (trans_response.status === 200) {
            divElement.innerHTML = "Image Inpainting in-progress....";

            var table = document.getElementById("editoptions");
            if (table) {
              table.style.display = "block";
            }

            const imageUrl = response.data.result.file_path;

            const img = new Image();
            img.onload = function () {
              const width = img.naturalWidth;
              const height = img.naturalHeight;

              // JavaScript
              const myElement = document.getElementById("canvas_div");
              myElement.style.height = height + "px"; // Set height dynamically
              myElement.style.width = width + "px"; // Set width dynamically
              myElement.style.border = "1px solid #ccc";

              const canvas = new fabric.Canvas(canvasRef.current, {
                width: width,
                height: height,
              });

              toBase64DataURL(imageUrl, function (dataUrl) {
                setLoading(false);

                // Add background image
                fabric.Image.fromURL(dataUrl, (img) => {
                  canvas.setBackgroundImage(
                    img,
                    canvas.renderAll.bind(canvas),
                    {
                      scaleX: canvas.width / img.width,
                      scaleY: canvas.height / img.height,
                    }
                  );
                });

                // Create the polygon
                trans_response.data.result.translated_text.forEach((item) => {
                  const polygon = [
                    item.polygon[0],
                    item.polygon[1],
                    item.polygon[2],
                    item.polygon[3],
                    item.polygon[4],
                    item.polygon[5],
                    item.polygon[6],
                    item.polygon[7],
                  ];

                  const text = item.content;
                  const font =
                    parseInt(item.polygon[7]) - parseInt(item.polygon[1]) - 5;
                  const color = item?.color ? item?.color : "black";
                  const fontWeight = item?.fontWeight
                    ? item?.fontWeight
                    : "normal";
                  const fontFamily = item?.similarFontFamily
                    ? item?.similarFontFamily
                    : "Arial, Helvetica, sans-serif";
                  const textBackgroundColor = item?.backgroundColor
                    ? item?.backgroundColor
                    : "";

                  // Calculate the center of the polygon
                  const centerX = (polygon[0] + polygon[4]) / 2;
                  const centerY = (polygon[1] + polygon[5]) / 2;

                  // Set the font size and color
                  const textObj = new fabric.IText(text, {
                    left: centerX,
                    top: centerY,
                    fontSize: font,
                    fontWeight: fontWeight,
                    fontFamily: fontFamily,
                    // textBackgroundColor: textBackgroundColor1,
                    fill: color,
                    originX: "center",
                    originY: "center",
                  });

                  // Calculate the rotation angle based on the slope of the polygon sides
                  const angleRadians = Math.atan2(
                    polygon[5] - polygon[1],
                    polygon[4] - polygon[0]
                  );

                  if (angleRadians < 1) {
                    textObj.set("angle", 0 * (180 / Math.PI));
                  } else {
                    textObj.set("angle", angleRadians * (180 / Math.PI));
                  }

                  canvas.add(textObj);
                });

                // Track Mouse Event
                canvas.on("mouse:down", (event) => {
                  if (event.target) {
                    canvas.setActiveObject(event.target);
                  } else {
                    canvas.discardActiveObject().renderAll();
                  }
                });

                // Font Color
                const colorInput = document.getElementById("color");

                colorInput.addEventListener("input", () => {
                  const activeObject = canvas.getActiveObject();
                  if (activeObject) {
                    activeObject.set("fill", colorInput.value);
                    canvas.renderAll();
                  }
                });

                // Font Size
                const fontSizeInput = document.getElementById("fontSize");

                fontSizeInput.addEventListener("input", () => {
                  const activeObject = canvas.getActiveObject();
                  if (activeObject) {
                    activeObject.set(
                      "fontSize",
                      parseInt(fontSizeInput.value, 10)
                    );
                    canvas.renderAll();
                  }
                });

                // Add new text
                const newTextInput = document.getElementById("newText");
                const addTextButton = document.getElementById("addText");

                addTextButton.addEventListener("click", () => {
                  const newText = newTextInput.value;
                  const x = Math.random() * canvas.getWidth();
                  const y = Math.random() * canvas.getHeight();
                  const font = fontSizeInput.value + "px Arial";
                  const color = colorInput.value;

                  // Set the font size and color
                  const textObjNew = new fabric.IText(newText, {
                    left: 50,
                    top: 50,
                    fontSize: 32,
                    fill: "black",
                    originX: "center",
                    originY: "center",
                  });

                  canvas.add(textObjNew);
                  newTextInput.value = "";
                });

                // font options
                const fontSelect = document.getElementById("font");

                fontSelect.addEventListener("change", () => {
                  const activeObject = canvas.getActiveObject();
                  if (activeObject) {
                    const selectedFont = fontSelect.value;
                    activeObject.set("fontFamily", selectedFont);
                    canvas.renderAll();
                  }
                });

                const boldText = document.getElementById("boldtext");

                boldText.addEventListener("change", () => {
                  const activeObject = canvas.getActiveObject();
                  if (activeObject) {
                    if (boldText.value == "bold") {
                      activeObject.set("fontWeight", "bold");
                    } else {
                      activeObject.set("fontWeight", "normal");
                    }
                    boldText.selectedIndex = 0;
                    canvas.renderAll();
                  }
                });

                const italicText = document.getElementById("italictext");

                italicText.addEventListener("change", () => {
                  const activeObject = canvas.getActiveObject();
                  if (activeObject) {
                    if (italicText.value == "italic") {
                      activeObject.set("fontStyle", "italic");
                    } else {
                      activeObject.set("fontStyle", "");
                    }
                    italicText.selectedIndex = 0;
                    canvas.renderAll();
                  }
                });
              });
            };
            img.src = imageUrl;
          } else {
            alert("Not Done");
          }
        } catch (error) {
          // Handle errors if any
          console.log(error);
        } finally {
          // Hide the loader on success or error
        }
      } else if (response.status === 400) {
        navigate("/JaduiDarpan/");
      } else {
        alert("Not Done");
      }
    } catch (error) {
      // Handle errors if any
      if (error.response.data.error_status) {
        setLoading(false);
        toast.error(error.response.data.error, {
          // Position of the toast on the screen
          position: "top-right", // Options: 'top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left'
          // Auto-close the toast after a specified duration (in milliseconds)
          autoClose: 5000, // Example: 5000 milliseconds (5 seconds)
          onClose: () => {
            navigate("/JaduiDarpan/");
          },
        });
      }
    }
  };

  const toBase64DataURL = (url, callback) => {
    let xhRequest = new XMLHttpRequest();
    xhRequest.onload = function () {
      let reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhRequest.response);
    };
    xhRequest.open("GET", url);
    xhRequest.responseType = "blob";
    xhRequest.send();
  };

  const downloadCanvasImage = (file_type) => {
    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL("image/jpg"); // You can change 'image/png' to the desired format
    let outputString = "";

    if (file_type == "jpg") {
      outputString = dataURL.replace("data:image/png;", "data:image/jpg;");
    }

    if (file_type == "png") {
      outputString = dataURL.replace("data:image/jpg;", "data:image/png;");
    }

    // Create a temporary anchor element for downloading
    const a = document.createElement("a");
    a.href = outputString;
    a.download = "translated-image.jpg"; // Specify the filename
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  function showdiv() {
    var table = document.getElementById("editoptions");
    if (editimg) {
      table.style.display = "block";
    }
  }
  return (
    <div>
      <div className="page-container page02 mt-5">
        <div className="text-start">
          {/* <h1>Translator App</h1> */}
          <button
            className="btn button orange chooseNew"
            style={buttonStyleNew}
            onClick={() => navigate("/JaduiDarpan")}
          >
            Back
          </button>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 text-start">
            <div className="minWidth">
              <h2 style={{ display: "block" }}>Original Image</h2>
              <div
                style={{
                  border: "1px solid #ccc",
                  minHeight: "200px",
                  width: "100%",
                }}
              >
                {selectedImage && (
                  <img src={URL.createObjectURL(selectedImage)} />
                )}
                {imageUrl && (
                  <img src={imageUrl} alt="Original" id="OriginalImg" />
                )}
              </div>
            </div>
          </div>
          {loading && (
            <>
              <div className="mainLoader tnansloader">
                <div className="maxheight">
                  <div className="loader"></div>
                  <div
                    id="loader_text"
                    style={{
                      fontSize: "30px",
                      color: "#fff",
                      padding: "10px",
                      borderRadius: "5px",
                      zIndex: "9999",
                      display: "block",
                    }}
                    className="overlay"
                  >
                    Image Inpainting in-progress....
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="page-container">
        <div className="row align-items-center imgOcr pt-5">
          {/* <div className={steps === true ? 'col-12 col-sm-12 col-md-4 col-lg-4 active' : 'col-12 col-sm-12 col-md-4 col-lg-4 hideDiv'}>
          <h2>Choose Image</h2>
          <input type="file" className='form-control' name='file' onChange={(event) => handleImageChange(event)} accept='img/*' />
        </div>
        <div className={steps === true ? 'col-12 col-sm-12 col-md-4 col-lg-4 active' : 'col-12 col-sm-12 col-md-4 col-lg-4 hideDiv'}>
          <h2>Select Language</h2>
          <select className='form-control' value={selectedLanguage} onChange={handleLanguageChange}>
            <option value="">Translate another Image file</option>
            {Indianlanguages.map(language => (
              <option value={language.value}>{language.name}</option>
            ))}
          </select>
        </div>
        <div className={steps === true ? 'col-12 col-sm-12 col-md-2 col-lg-2 active' : 'col-12 col-sm-12 col-md-2 col-lg-2 hideDiv'}>
          <button className="btn button orange" style={buttonStyle} onClick={() => translateImage(selectedLanguage, selectedImage)}>Translate</button>
        </div> */}
        </div>
      </div>

      <div className="row transimg">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-start">
          <div style={{ width: "100%" }}>
            <div className="d-flex justify-content-end">
              <h2>Traslated Image</h2>
              <div
                class="col-12 col-sm-12 col-md-8 col-lg-8"
                style={{ textAlign: "right" }}
              >
                {/* <button className="btn button orange chooseNew mt-0" style={{ marginRight: '10px' }} onClick={() =>showdiv()}>Edit Image </button> */}
                <button
                  className="btn button orange chooseNew mt-0"
                  style={{ marginRight: "10px" }}
                  onClick={() => downloadCanvasImage("jpg")}
                >
                  Download as JPG file{" "}
                </button>
                <button
                  className="btn button orange chooseNew mt-0"
                  onClick={() => downloadCanvasImage("png")}
                >
                  Download as PNG file{" "}
                </button>
              </div>
            </div>
            <div className="row imgOcr editoptn">
              <div id="editoptions" style={{ display: "none" }}>
                <div className="d-flex justify-content-between text-start">
                  <div className="d-flex justify-content-between text-start minWidth">
                    <div style={{ padding: "10px" }}>
                      <label for="font">Font: </label>
                      <select id="font" className="form-control">
                        <option value="Arial">Arial</option>
                        <option value="Verdana">Verdana</option>
                        <option value="Times New Roman">Times New Roman</option>
                        <option value="Courier New">Courier New</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Tahoma">Tahoma</option>
                        <option value="Comic Sans MS">Comic Sans MS</option>
                        <option value="Impact">Impact</option>
                        <option value="Lucida Console">Lucida Console</option>
                        <option value="Palatino Linotype">
                          Palatino Linotype
                        </option>
                        <option value="Trebuchet MS">Trebuchet MS</option>
                        <option value="Century Gothic">Century Gothic</option>
                        <option value="Book Antiqua">Book Antiqua</option>
                        <option value="Franklin Gothic Medium">
                          Franklin Gothic Medium
                        </option>
                        <option value="Copperplate">Copperplate</option>
                        <option value="Garamond">Garamond</option>
                        <option value="Rockwell">Rockwell</option>
                        <option value="Segoe UI">Segoe UI</option>
                        <option value="Arial Black">Arial Black</option>
                      </select>
                    </div>
                    <div style={{ padding: "10px", minWidth: 130 }}>
                      <label for="fontSize">Font Size: </label>
                      <select class="form-control" id="fontSize"></select>
                    </div>
                    <div style={{ padding: "10px" }}>
                      <label htmlFor="color">Font Color: </label>
                      <input
                        type="color"
                        className="form-control"
                        id="color"
                        defaultValue="#000000"
                      />
                    </div>

                    <div style={{ padding: "10px" }}>
                      <label htmlFor="boldtext">Bold: </label>&nbsp;
                      <select id="boldtext" className="form-control">
                        <option value="">Select</option>
                        <option value="bold">Bold</option>
                        <option value="normal">Normal</option>
                      </select>
                    </div>

                    <div style={{ padding: "10px" }}>
                      <label htmlFor="italictext">Italic: </label>&nbsp;
                      <select id="italictext" className="form-control">
                        <option value="">Select</option>
                        <option value="italic">Italic</option>
                        <option value="nonitalic">Non-Italic</option>
                      </select>
                    </div>
                  </div>
                  <div style={{ padding: "10px" }}>
                    <div className="d-flex justify-content-end align-items-end">
                      <div>
                        <label for="newText">Add Text: </label>
                        <input
                          type="text"
                          style={{ maxWidth: 190 }}
                          className="form-control"
                          id="newText"
                          placeholder="Enter text"
                        />
                      </div>
                      <button
                        id="addText"
                        style={{
                          marginLeft: 8,
                          height: 45,
                          padding: "0px 10px",
                        }}
                        className="button green"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
                {keyboardview ? (
                  <>
                    <button
                      className="btn button orange chooseNew mt-0"
                      onClick={() => setkeyboardview(!keyboardview)}
                    >
                      Virtual keyboard
                    </button>{" "}
                    <TranslatorInput />
                  </>
                ) : (
                  <>
                    {" "}
                    <button
                      className="btn button orange chooseNew mt-0"
                      onClick={() => setkeyboardview(!keyboardview)}
                    >
                      Virtual keyboard
                    </button>{" "}
                  </>
                )}
              </div>
            </div>

            <div className="transBrd">
              <div id="canvas_div" ref={divRef}>
                <canvas ref={canvasRef} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="image-container">
        {/* <div>
          
          <h2>Translated Image</h2>
          <div className="translated-image">
            {imageData?<>
              <img
              src={imageData}
              alt="Translated"
            />
            </>:<></>}
            
            <button  type="button">  <a href='edi'> Edit</a></button>
            
           
            <button type="button"> Save</button>
          </div>
        </div> */}
      </div>
      {/* Loader */}
    </div>
  );
};

export default Translator;
